import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a small countertop espresso machine, ~0.3 x 0.3 x 0.4 m.
// Authored at floor level; the builder sets it on a 0.9 m worktop.
const STEEL = "#aab2b8";
const STEEL_DARK = "#9aa2a8";
const MATTE_BLACK = "#2e2e30";
const CUP = "#efece6";

export const coffeeMachine = defineModel({
  id: "coffee-machine",
  batchId: "modern",
  name: "Coffee machine",
  tags: ["modern", "interior", "appliance", "kitchen", "coffee", "countertop"],
  summary: "A small steel espresso machine with a group head and a cup on the drip tray.",
  tiles: { w: 1, h: 1 },
  footprint: 0.6,
  parts(): Part[] {
    return [
      // drip tray base
      { geometry: new THREE.BoxGeometry(0.28, 0.04, 0.26), color: MATTE_BLACK, position: [0, 0.02, 0.01] },
      // body tower at the back
      { geometry: new THREE.BoxGeometry(0.28, 0.34, 0.16), color: STEEL, position: [0, 0.21, -0.06] },
      // top plate (cup warmer)
      { geometry: new THREE.BoxGeometry(0.28, 0.03, 0.24), color: STEEL_DARK, position: [0, 0.395, -0.02] },
      // group head protruding forward
      { geometry: new THREE.BoxGeometry(0.1, 0.07, 0.1), color: STEEL_DARK, position: [0, 0.27, 0.04] },
      // spout under the group head
      { geometry: new THREE.CylinderGeometry(0.015, 0.015, 0.05, 8), color: MATTE_BLACK, position: [0, 0.21, 0.06] },
      // portafilter handle
      { geometry: new THREE.BoxGeometry(0.02, 0.02, 0.09), color: MATTE_BLACK, position: [0, 0.245, 0.13] },
      // cup on the drip tray
      { geometry: new THREE.CylinderGeometry(0.032, 0.026, 0.06, 10), color: CUP, position: [0, 0.07, 0.06] },
    ];
  },
  animations: [],
});
